import {useTranslation} from 'react-i18next';
import {Route, Routes} from 'react-router-dom';
import {DamagePriceTable} from '../component/damagePriceList/DamagePriceList'
import SectionHeader from "../../../util/component/SectionHeader";
import React from "react";

const DamagePage = () => {
    const {t} = useTranslation(["operation"]);
    return (
        <div>
            <SectionHeader
                title={t("dangerPrice.titleFirst") + " " + t("dangerPrice.titleSecond")}
            />
            <Routes><Route path="/" element={<DamagePriceTable/>}/></Routes>
        </div>

    );
}

export default DamagePage;